const StorageCategoriesDetailsMap = {
    [HStoragePolicyManager.Categories.NECESSARY]: {
        label: 'Necessary',
        description: 'These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms.'
    },
    [HStoragePolicyManager.Categories.PREFERENCES]: {
        label: 'Preferences',
        description: 'These cookies allow the website to remember choices you make (such as your user name, language or the region you are in) and provide enhanced, more personal features.'
    },
    [HStoragePolicyManager.Categories.ANALYTICS]: {
        label: 'Analytics',
        description: 'These cookies help us to understand how visitors interact with our website, discover errors and provide a better overall analytics.'
    },
    [HStoragePolicyManager.Categories.MARKETING]: {
        label: 'Marketing',
        description: 'These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites.'
    }
}

let hideStoragePolicyModal;

function assignStorageModalHandlers(modal) {
    modal.querySelector('#storage-policy-modal-close-btn').addEventListener('click', () => {
        hideStoragePolicyModal();
    });
    modal.querySelector('#storage-deny-btn').addEventListener('click', () => {
        HStoragePolicyManager.deny();
        hideStoragePolicyModal();
        hideStoragePolicyBanner();
    });
    modal.querySelector('#storage-accept-all-btn').addEventListener('click', () => {
        HStoragePolicyManager.allowAll();
        hideStoragePolicyModal();
        hideStoragePolicyBanner();
    });
    modal.querySelector('#storage-allow-selection-btn').addEventListener('click', () => {
        const allowedCategories = [];
        HStorageItems.forEach(cat => {
            if (modal.querySelector(`#cat-${cat.code}-is-enabled`).checked) {
                allowedCategories.push(cat.code);
            }
        })
        HStoragePolicyManager.allowSelection(allowedCategories);
        hideStoragePolicyModal();
        hideStoragePolicyBanner();
    });
}

const modalStyle = `
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 8px;
    box-shadow: 0 32px 68px rgba(0, 0, 0, .3);
    box-sizing: border-box;
    font-size: 15px;
    height: auto;
    max-width: 900px;
    left: 50%;
    line-height: 24px;
    overflow: hidden;
    position: fixed;
    text-align: initial;
    top: 3rem;
    transform: translateX(-50%);
    transition: all .5s ease;
    transition-property: width, max-width, top, bottom, left, opacity;
    z-index: 2147483632;
    max-height: 97vh;
    overflow-y: auto;
    `;

const backdropStyle = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2147483631;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 3rem;
`;

const btnStyle = `
    font-size: 1rem;
    padding-inline: 15px;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: 1px solid;
    white-space: nowrap;
`;

const solidBtnStyle = `
    border-color: #0088dd;
    background-color: #0088dd;
    color: #ffffff;
`;

function showStoragePolicyModal() {

    if (!document.querySelector('#storage-policy-modal-responsive-style')) {
        const styleTag = document.createElement('style');
        styleTag.id = 'storage-policy-modal-responsive-style';
        styleTag.innerHTML = `
            #storage-policy-modal { width: 800px; max-width: 900px; }
            @media (max-width: 992px) {
                #storage-policy-modal { width: 95%; padding-bottom: 20px; }
                #storage-policy-modal .storage-policy-modal-footer { flex-direction: column; }
                #storage-policy-modal .storage-policy-modal-buttons { flex-direction: column; width: 100%; }
            }
        `;
        document.head.appendChild(styleTag);
    }

    const html = `
    <div style="${backdropStyle}" id="storage-policy-backdrop">
        <div style="${modalStyle}" id="storage-policy-modal">
            <div style="padding: 18px 15px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #ddd;">
                <h5 style="margin-bottom: 0; line-height: 1.5; font-size: 1.25rem;">Manage Cookies</h5>
                <button style="background-color: #DFE4EA; border: 0; border-radius: 50%; width: 25px; height: 25px; display: flex; justify-content: center; align-items: center;"
                        type="button"
                        id="storage-policy-modal-close-btn"
                        aria-label="Close">
                    <span style="font-size: 23px;font-weight: 200;" aria-hidden="true">&times;</span>
                </button>
            </div>
            <div style="padding: 0 15px;">
                <ul style="list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 1rem;">
                ${HStorageItems.map(cat => {return `
                    <li id="storage-cat-${cat.code}">
                        <div style="display: flex; flex-direction: column; gap: 1rem; background: #F8F9FB; padding: 1rem; border-radius: 3px">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <h3 style="font-size: 16px;font-weight: 500;">${StorageCategoriesDetailsMap[cat.code].label}</h3>
                                <input style="width: 16px; height: 16px;" ${cat.alwaysEnabled ? 'disabled' : ''} id="cat-${cat.code}-is-enabled" type="checkbox" ${HStoragePolicyManager.isCategoryEnabled(cat.code) ? 'checked' : ''} />
                            </div>
                            <p style="font-size: 14px; margin: 0">${StorageCategoriesDetailsMap[cat.code].description}</p>
                        </div>
                      </li>`;}).join('')}
                </ul>
            </div>
            <div class="storage-policy-modal-footer" style="display: flex; justify-content: space-between; align-items: center; gap: 10px; padding: 15px; border-top: 1px solid #ddd;">
                <a href="/cookie-policy" target="_blank">Cookies policy</a>
                <div class="storage-policy-modal-buttons" style="display: flex; justify-content: end; gap: 10px;">
                    <button style="${btnStyle} ${solidBtnStyle}" id="storage-deny-btn">
                        Decline all non-essential cookies
                    </button>
                    <button style="${btnStyle} ${solidBtnStyle}" id="storage-allow-selection-btn">
                        Allow selection
                    </button>
                    <button style="${btnStyle} ${solidBtnStyle}" id="storage-accept-all-btn">
                        Allow all
                    </button>
                </div>
            </div>
        </div>
    </div>
    `;

    const container = document.createElement('div');
    container.innerHTML = html;
    const backdrop = container.firstElementChild;
    const modal = backdrop.querySelector('#storage-policy-modal');
    document.body.append(backdrop);
    
    // Add backdrop click handler to close modal
    backdrop.addEventListener('click', (e) => {
        if (e.target === backdrop) {
            hideStoragePolicyModal();
        }
    });
    
    setTimeout(() => {
        assignStorageModalHandlers(modal);
    }, 1);

    return () => {
        backdrop.remove();
    }
}

let hideStoragePolicyBanner;

function assignStorageBannerHandlers(banner) {
    banner.querySelector('#manage-storage-policy-btn').addEventListener('click', () => {
        hideStoragePolicyModal = showStoragePolicyModal();
    });

    banner.querySelector('#storage-banner-accept-all-btn').addEventListener('click', () => {
        HStoragePolicyManager.allowAll();
        hideStoragePolicyBanner();
    });

    banner.querySelector('#storage-banner-reject-all-btn').addEventListener('click', () => {
        HStoragePolicyManager.deny();
        hideStoragePolicyBanner();
    });
}

function showStoragePolicyModalFromFooter() {
    const footerManageStoragePolicyBtn = document.querySelector('#footer-manage-storage-policy-btn');
    if (!footerManageStoragePolicyBtn) {
        return;
    }
    footerManageStoragePolicyBtn.addEventListener('click', () => {
        hideStoragePolicyModal = showStoragePolicyModal();
    });
}

const bannerAllowBtnStyle = `
    border-color: #0088dd;
    background: #0088dd;
    color: #fff;
`;

const bannerManageBtnStyle = `
    border-color: #0088dd;
    background: #fff;
    color: #0088dd;
`;

const bannerRejectBtnStyle = `
    border-color: #0088dd;
    background: #0088dd;
   color: #fff;
`;

const bannerStyle = `
position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    padding: 15px 20px;
    z-index: 2147483631;
    box-shadow: 0px 0px 17px -6px rgba(0, 0, 0, 0.75);
`;

function showStoragePolicyBanner(options) {
    if (document.querySelector('#storage-policy-banner')) {
        return hideStoragePolicyBanner;
    }

    if (!document.querySelector('#storage-banner-responsive-style')) {
        const bannerContentStyles = `
        .banner-content {
            display: flex;
            justify-content:
            space-between;
            align-items: center; 
            gap: 30px;
        }
        
        .banner-buttons { 
           display: flex; 
           flex-direction: column; 
           align-items: stretch;
           gap: 10px;
        }
        
        .banner-btn {
            font-size: 1rem;
            padding-inline: 30px;
            min-height: 40px;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            border: 1px solid;
            white-space: nowrap;
        }
        
       @media (max-width: 768px) {
          #storage-policy-banner .banner-content {
            flex-direction: column;
            align-items: center;
            gap: 10px;
            font-size: 0.8rem;
          }
          
          #storage-policy-banner .banner-buttons {
            font-size: 0.8rem;
            gap: 5px; 
            min-height: 30px; 
            justify-content: space-between;
            width: 100%;
          }
          
          #storage-policy-banner .banner-buttons .banner-btn {
            min-height: 30px; 
            font-size: 0.8rem;
          }
         }
        `;

        const styleTag = document.createElement('style');
        styleTag.id = 'storage-banner-responsive-style'; // avoid duplicates
        styleTag.innerHTML = bannerContentStyles;
        document.head.appendChild(styleTag);
    }
    
    const { countryCode } = options;
    const UK_TEXT = `This website uses essential cookies to ensure it functions properly.
                If you give us your consent, we will set non-essential cookies and other tracking technologies,
                including pixels and web beacons, to collect and share with our third-party analytics/advertising providers
                your internet or other electronic network activity and personal identifiers (including IP addresses and device identifiers)
                for purposes of enhancing your browsing experience, delivering targeted advertisements, and analyzing the performance of our advertising campaigns.
                You can accept or reject our cookies by using the buttons on this banner. If you change your mind in the future,
                you can either use this banner's buttons again or you can go to our website and click on “Your privacy choices” in the footer of our website.
                For additional information and the retention terms for the trackers, please see our <a href="/cookie-policy" target="_blank">Cookie Policy</a>.
                Please see our <a href="/privacy" target="_blank">Privacy Notice</a> for information regarding our general collection and use of personal information.`;
    const US_TEXT = `This website uses essential cookies to ensure it functions properly.
                If you give us your consent, we will set non-essential cookies and other tracking technologies,
                including pixels and web beacons, to collect and share with our third-party analytics/advertising providers
                your internet or other electronic network activity and personal identifiers (including IP addresses and device identifiers)
                for purposes of enhancing your browsing experience, delivering targeted advertisements, and analyzing the performance of our advertising campaigns.
                You may modify or withdraw your consent at any time with effect moving forward by clicking “Your privacy choices” in the footer of the website.
                For additional information and the retention terms for the trackers, please see our <a href="/cookie-policy" target="_blank">Cookie Policy</a>.
                Please see our <a href="/privacy" target="_blank">Privacy Notice</a> for information regarding our general collection and use of personal information.`;
    
    const TEXT = countryCode === 'UK' ? UK_TEXT : US_TEXT;
    const html = `
    <div style="${bannerStyle}" id="storage-policy-banner">
        <div class="banner-content">
            <div>
                ${TEXT}
            </div>
            <div class="banner-buttons">
                <button class="banner-btn" style="${bannerAllowBtnStyle}" id="storage-banner-accept-all-btn">
                    Allow all
                </button>
                <button class="banner-btn" style="${bannerRejectBtnStyle}" id="storage-banner-reject-all-btn">
                    Decline all non-essential cookies
                </button>
                 <button class="banner-btn" style="${bannerManageBtnStyle}" id="manage-storage-policy-btn">
                    Your privacy choices
                </button>
            </div>
        </div>
    </div>
    `;

    const container = document.createElement('div');
    container.innerHTML = html;
    const banner = container.firstElementChild;
    document.body.append(banner);
    setTimeout(() => {
        assignStorageBannerHandlers(banner);
    }, 1);

    return () => {
        banner.remove();
    }
}


const initStoragePolicyBanner = (options) => {
    if (!HStoragePolicyManager.isPolicyChecked()) {
        setTimeout(function () {
            hideStoragePolicyBanner = showStoragePolicyBanner(options);
        }, 1000);
    }

    setTimeout(() => {
        showStoragePolicyModalFromFooter();
    }, 1000);
}


export { initStoragePolicyBanner };